import React from "react";
import * as PropTypes from "prop-types";

export const ScaleFeature = ({icon, title, description}) => (
    <div className="d-flex justify-content-center align-items-center">
      <img alt={icon} src={icon} className="img-fluid me-2" />
      <p className="feature-description p-0">
        <span className="feature-description fw-bold p-0">
          {title}{' '}
        </span>
        {description}
      </p>
    </div>
);

ScaleFeature.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

